import UniversalCookies, { CookieSetOptions } from "universal-cookie";
import { StorageInterface, StorageKeys } from "./StorageInterface";
import { VITE_SSL } from "../../constants/variables";

export class CookieStorage implements StorageInterface {
  private client: UniversalCookies;
  private options: CookieSetOptions;
  constructor() {
    this.client = new UniversalCookies();
    this.options = {
      secure: VITE_SSL === "true",
      path: "/",
    };
  }

  async get(key: string, defaultValue = ""): Promise<string> {
    return this.client.get(key, {}) ?? defaultValue;
  }

  async set(key: string, value: string): Promise<void> {
    return this.client.set(key, value, this.options);
  }

  async remove(key: string): Promise<void> {
    return this.client.remove(key, this.options);
  }

  async clear(): Promise<void> {
    const removePromises = Object.values(StorageKeys).map((key) =>
      this.remove(key),
    );
    await Promise.all(removePromises);
  }
}
